module.exports = __webpack_public_path__ + "static/media/Bands.43ec0a95.jpg";